import { createAction, props } from '@ngrx/store';
import { BannersEnum } from '../enums/banners.enum';

export const dismissBanner = createAction(
    '[User] Dismiss Banner',
    props<{ banner: BannersEnum }>()
);

export const dismissBannerSuccess = createAction(
    '[User] Dismiss Banner Success',
    props<{ dismissedBanners: BannersEnum[] }>()
);

export const dismissBannerFailure = createAction(
    '[User] Dismiss Banner Failure',
    props<{ error: any }>()
);


export const updateLastSeenReleaseId = createAction(
    '[User] Update Last Seen Release Id',
    props<{ releaseId: string }>()
);

export const updateLastSeenReleaseIdSuccess = createAction(
    '[User] Update Last Seen Release Id Success',
    props<{ releaseId: string }>()
);

export const updateLastSeenReleaseIdFailure = createAction(
    '[User] Update Last Seen Release Id Failure',
    props<{ error: any }>()
);
